module.exports = __webpack_public_path__ + "favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./src/trane.favicon.ico
// module id = 1284
// module chunks = 47